module.exports = __webpack_public_path__ + "static/media/02_web_website-tbd.69f836cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/02_web_website-tbd.jpg
// module id = 72
// module chunks = 0